var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.previewSrcList.length)?_c('viewer',{ref:"viewer",attrs:{"images":_vm.previewSrcList},on:{"inited":_vm.inited}},_vm._l((_vm.previewSrcList),function(item,index){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],key:index,attrs:{"src":item}})}),0):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }